document.addEventListener("DOMContentLoaded", function () {
  const countdownDuration = 600; 
  const minutesElement = document.getElementById("minutes");
  const secondsElement = document.getElementById("seconds");
  
 
  if (!minutesElement || !secondsElement) return;
 
  
  const timerWrapper = document.querySelector('.countdown_timer_section__wrapper');
  if (!timerWrapper) return;

  
  const referenceStart = new Date();
  referenceStart.setHours(0, 0, 0, 0);

  function getCurrentCycleTimeLeft() {
    const now = new Date();
    const elapsedSeconds = Math.floor((now - referenceStart) / 1000);
    const timeIntoCycle = elapsedSeconds % countdownDuration;
    return countdownDuration - timeIntoCycle;
  }

  function startCountdown() {
    let timeLeft = getCurrentCycleTimeLeft();

    function updateCountdown() {
      const minutes = Math.floor(timeLeft / 60);
      const seconds = timeLeft % 60;

    minutesElement.textContent = String(minutes).padStart(2, "0");
      secondsElement.textContent = String(seconds).padStart(2, "0");

      timeLeft--;

      if (timeLeft < 0) {
        timeLeft = countdownDuration; // Reset to 10 mins again
      }
    }

    updateCountdown();
 const countdownInterval = setInterval(updateCountdown, 1000);
  
    return function cleanUp() {
      clearInterval(countdownInterval);
    };
  }

  const cleanUpCountdown = startCountdown();
  window.addEventListener('beforeunload', cleanUpCountdown);
});